import { VariantService } from "./Service";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import { useSelector } from "react-redux";
import {
  checkActionPermission,
  checkPermission,
} from "../../core/routes/RouteValidator";
import $ from "jquery";
import { toast } from "react-hot-toast";
import XConstants from "../../core/config/Constants";
import { useEffect } from "react";
import JsBarcode from "jsbarcode";

const VariantManagement = ({product}: {product: string}) => {
  const service = new VariantService();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.auth);
  const company = useSelector((state: any) => state.company);

  const getItems = () => {
    try {
      $("#items").DataTable().destroy();
    } catch (e) {
      console.log(e);
    }
    let token = localStorage.getItem("token");
    $("#items").DataTable({
      lengthMenu: [10, 20, 50, 100, 500, 1000],
      pageLength: 100,
      processing: true,
      serverSide: true,
      columnDefs: [
        {
          render: function (data: string, type: any, row: any) {
            if (data === "Active") {
              return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
            } else {
              return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
            }
          },
          targets: 6,
        },
        {
          render: function (data: any, type: any, row: string[]) {
            if (row[6] === "Active") {
              return `<button class="btn btn-danger">Deactivate</button>`;
            } else {
              return `<button class="btn btn-success">Activate</button>`;
            }
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click(async (e: any) => {

              const status = rowData[6] === "Active" ? "Inactive" : "Active";
              const res = await service.update(rowData[8], {
                status: status,
              });
              if (res) {
                toast.success(`Variant updated successfully`, {});
                getItems();
              }
            });
          },
          targets: 8,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-primary">Details</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click((e: any) => {
              navigate(`/variants/${product!}/details/${cellData}`);
            });
          },
          targets: 9,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-danger">Delete</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click(async (e: any) => {
              const res = await service.update(rowData[10], {
                deleted: true,
              });
              if (res) {
                toast.success(`Variant deleted successfully`, {});
                getItems();
              }
            });
          },
          targets: 10,
        },
      ],
      ajax: {
        url: `${XConstants.baseUrl}/company/variant/list`,
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: token,
        },
        data: function (d: any) {
          return JSON.stringify({
            ...d,
            product: product,
          });
        },
      },
    });
  };

  useEffect(() => {
    getItems();
  }, []);


  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Variants</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link className="btn btn-primary" to={`/variants/${product}/add`}>
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                  Add Variant
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="card col-12">
          <div className="card-body w-100">
            <div className="table-responsive w-100">
              <table id="items" className="table datatable  w-100">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Size</th>
                    <th>Type</th>
                    <th>Sale Price</th>
                    <th>Purchase Price</th>
                    <th>Discount</th>
                    <th>Status</th>
                    <th>Added Date</th>
                    <th>Change Status</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VariantManagement;
